const de = {
  nav: { about: "Über uns", services: "Leistungen", logistics: "Logistik", clients: "Kunden", news: "News", contact: "Kontakt", cta: "Beratung anfragen", menu: "Menü", close: "Schließen" },
  global: {
    eyebrow: "Die Welt in Bewegung",
    title: "Von der Küste zu den _großen Hauptstädten_.",
    intro: "Menschen, die Geschäfte machen, Waren unterwegs: Das ist die Welt, in der wir täglich arbeiten.",
    capitals: "Große Hauptstädte",
    deals: "Menschen & Geschäfte",
    base: "Meine Basis: die Küste",
    ops: "Waren unterwegs",
    timezones: "Zeitzonen",
    newsTicker: "Weltnachrichten · immer aktuell · weiter unten im Bereich News & Märkte",
  },
  news: {
    eyebrow: "06 — News & Märkte",
    title: "Die Welt des Transports, _in Echtzeit_.",
    intro: "Schlagzeilen automatisch von den führenden Logistikportalen aktualisiert.",
    read: "Lesen",
    updated: "Aktualisiert",
  },
  hero: {
    eyebrow: "Unternehmensberatung · Import Export · Logistik",
    lines: ["Wir bringen", "Unternehmen", "_über_ Grenzen."],
    sub: "Wir begleiten Unternehmen bei Import und Export, Dokumentenverfahren, dem Eintritt in neue Märkte und internationaler Logistik: vom ersten Kontakt bis zur Zustellung.",
    cta: "Sprechen wir über Ihr Projekt",
    cta2: "Leistungen ansehen",
    scroll: "Scrollen",
    tags: ["See", "Luft", "Land", "Kurier"],
    frame: "Globale Routen, ein einziger Ansprechpartner",
  },
  marquee: ["Import · Export", "Dokumentenverfahren", "Temperaturgeführt", "Gefahrgut DGR", "Seefracht", "Luftfracht", "Straßentransport", "Lagerung & Verpackung", "Marktentwicklung"],
  about: {
    eyebrow: "01 — Über uns",
    title: "Ein Berater, ein Netzwerk, _eine Methode_ für Wachstum im Ausland.",
    body1: "MF Logistics Consulting Group bietet Unternehmen einen zentralen Ansprechpartner, wenn sie über nationale Grenzen hinaus verkaufen, einkaufen oder produzieren möchten.",
    body2: "Wir verbinden Dokumenten-Know-how, Marktkenntnis und operative Logistik, um aus einer Expansionsidee einen echten Fluss von Waren, Verträgen und Beziehungen zu machen.",
  founderRole: "Gründerin & CEO",
  founderLine: "Langjährige internationale Erfahrung in Europa und weltweit: Ich begleite Unternehmen über Grenzen hinweg – mit Sorgfalt und Methode.",
  doorCaption: "Meine Tür ist immer offen",
    pillars: [
      { t: "Gesamtblick", d: "Vertriebsstrategie, Dokumente und Transport als ein Projekt." },
      { t: "Echte Umsetzung", d: "Wir begleiten jede Sendung und jeden Vorgang bis zum Abschluss." },
      { t: "Kontaktnetzwerk", d: "Ausgewählte Partner, Lieferanten und Käufer in den Zielmärkten." },
    ],
  },
  services: {
    eyebrow: "02 — Leistungen",
    title: "Maßgeschneiderte Beratung, _vom Papier_ bis zum Container.",
    intro: "Jedes Unternehmen ist anders: Wir gestalten den Weg, der zu Ihrem passt.",
    items: [
      { t: "Import & Export", d: "Planung der Warenströme, Incoterms, Lieferanten und Logistikpartner für sicheren Ein- und Verkauf im Ausland." },
      { t: "Dokumentenverfahren", d: "Zollabwicklung, Ursprungszeugnisse, Transportdokumente und Compliance – präzise erledigt." },
      { t: "Markteinführung von Produkten", d: "Analyse des Zielmarkts, Eintrittsvoraussetzungen und Launch-Strategie für Ihre Produkte." },
      { t: "Geschäftsentwicklung im Ausland", d: "Internationalisierungspläne und kommerzielles Wachstum in neuen Ländern und Kanälen." },
      { t: "Kontaktaufbau", d: "Suche und Qualifizierung von Käufern, Händlern und Partnern im Zielmarkt." },
      { t: "Aufträge ausländischer Märkte", d: "Recherche internationaler Kunden und Bearbeitung ihrer Anfragen – vom ersten Kontakt bis zur Bestellung." },
      { t: "Unternehmensberatung", d: "Unterstützung bei Organisation, Prozessen und allen weiteren unternehmerischen Fragen." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logistik",
    title: "Jede Ware, _jede_ Route.",
    intro: "Wir organisieren komplette Sendungen für jede Warenart und jeden Verkehrsträger – inklusive Lagerung und Verpackung.",
    modesTitle: "Verkehrsträger",
    modesDesc: "Wir kombinieren Schiff, Flugzeug, Straße und Kurier für die richtige Balance aus Zeit, Kosten und Sicherheit.",
    modes: ["Schiff", "Flugzeug", "Straße", "Kurier"],
    goodsTitle: "Warenarten",
    goods: [
      { t: "Umgebungstemperatur — General Cargo", d: "Stückgut, Sammelgut und Komplettladungen." },
      { t: "Temperaturgeführt", d: "Kühlkette und definierte Temperaturbereiche." },
      { t: "Gefahrgut DGR", d: "Dokumentation und Abwicklung nach ADR / IMDG / IATA." },
    ],
    subsLabel: "Fracht-Unterkategorien",
    subs: ["Lebensmittel & Frischware (auch gefroren)", "Pharma", "Maschinen & Anlagen", "Luxusgüter", "Bekleidung", "Kosmetik", "…und mehr"],
    insurance: { t: "Warenversicherung", d: "Vollständige Absicherung Ihrer Fracht auf jeder Etappe." },
    docsPermits: { t: "Dokumente & Genehmigungen", d: "Registrierungen, Gesundheitszertifikate, Einfuhrgenehmigungen und jeder Vorgang." },
    palletControl: { t: "Palettierung & Kontrolle", d: "Lagerung, Palettierung und Warenkontrolle im Lager." },
    warehousing: { t: "Lagerung", d: "Einlagerung, Bestandsführung und Distribution." },
    packaging: { t: "Verpackung", d: "Verpackung passend zu Ware, Transportweg und Vorschriften." },
    customs: { t: "Dokumente & Zoll", d: "Vom Konnossement bis zum Zertifikat: alles an seinem Platz." },
  },
  newsletter: {
    eyebrow: "Der Newsletter",
    titleAccent: "Bleib auf dem Laufenden",
    title: " — weltweit.",
    sub: "Jeden Monat: Routen, Märkte und praktische Tipps für Handel über Grenzen hinweg. Kein Spam.",
    placeholder: "Deine E-Mail",
    cta: "Abonnieren",
    sending: "Wird gesendet…",
    ok: "Anmeldung bestätigt! Du erhältst unsere News.",
    already: "Du bist bereits angemeldet.",
    error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    privacy: "Mit der Anmeldung erhältst du unsere Nachrichten. Kein Spam: jederzeit abbestellbar.",
  },
  clients: {
    eyebrow: "04 — Kunden",
    title: "Unternehmen, die sich für _unsere Leistungen_ entschieden haben.",
    intro: "Einige der Unternehmen, die wir auf internationalen Märkten begleitet haben.",
    consTitle: "Mit _Beratung_.",
    impTitle: "Mit _Import-Export_.",
    placeholder: "[Kundenlogo]",
    visit: "Besuchen",
  },
  contact: {
    eyebrow: "05 — Kontakt",
    title: "Sagen Sie uns, _wohin_ Sie wollen.",
    intro: "Schreiben Sie uns: Wir melden uns, um gemeinsam den besten Weg zu finden.",
    fields: { name: "Vor- und Nachname", company: "Unternehmen", email: "E-Mail", phone: "Telefon", service: "Was benötigen Sie?", message: "Nachricht" },
    servicePick: "Leistung auswählen",
    logisticsOption: "Versand & Logistik",
    submit: "Anfrage senden",
    sending: "Wird gesendet…",
    success: "Vielen Dank! Wir haben Ihre Anfrage erhalten und melden uns in Kürze.",
    error: "Senden fehlgeschlagen. Bitte prüfen Sie die Felder und versuchen Sie es erneut.",
    direct: "Direkter Kontakt",
    emailLabel: "E-Mail",
    phoneLabel: "Telefon",
    vatLabel: "USt-IdNr.",
    addressLabel: "Sitz",
  },
  footer: { tagline: "Unternehmensberatung, Import-Export und internationale Logistik.", rights: "Alle Rechte vorbehalten.", admin: "Admin-Bereich", top: "Nach oben" },
};
export default de;
